<template>
  <div id="examLoginAbnormal">
    <template v-if="$route.name === 'examLoginAbnormal'">
        <ots-main-title></ots-main-title>
        <el-form>
            <div class="mainCon mainBox">
                <div style="display:flex; flex-wrap: wrap;" class="examLoginAbnormal">
                    <el-form-item label="考试批次：" style="margin-right: 10px;">
                        <el-select v-model="selectForm.planId" filterable @change="getSessionList">
                            <el-option v-for="item in planList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="场次：" style="margin-right: 10px;">
                        <el-select v-model="selectForm.sessionId" placeholder="请选择" filterable>
                            <el-option v-for="item in sessionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="登录时间：" style="margin-right: 10px; display: flex;" class="ShortSelect">
                      <el-date-picker v-model="selectForm.queryDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                      <el-select v-model="selectForm.queryTimeL" style="margin-left: 10px;" >
                        <el-option
                          v-for="hour in 24"
                          :key="hour"
                          :label="`${String(hour-1).padStart(2, '0')}时`"
                          :value="hour-1"
                        >
                        </el-option>
                      </el-select>
                      <span style="margin: 0 8px;">至</span>
                      <el-select v-model="selectForm.queryTimeR">
                        <el-option
                          v-for="hour in 24"
                          :key="hour"
                          :label="`${String(hour-1).padStart(2, '0')}时`"
                          :value="hour-1"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" round @click="getResult"> 查询 </el-button>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="mainCon">
            <ots-table :tableHeader="tableHeader" :tableData="tableData"></ots-table>
            <ots-pagination :pagination="pagination" @changeNum="changeSize" @changePage="changePage"></ots-pagination>
        </div>
    </template>
    <template v-else>
        <router-view></router-view>
    </template>
    <!-- 添加弹窗 -->
    <ots-custom-dialog :dialog.sync="logDialog" title="登录日志" width="40%">
      <template v-slot:content>
        <div>
          <ul class="ulA">
            <li>学生姓名：{{logData.realName}}</li>
            <li>准考证号：{{logData.entranceCode}}</li>
            <li>证件号码：{{logData.cardNo}}</li>
            <li>登录时间：<span v-if="getLoading">正在查询中，等稍后</span></li>
          </ul>
          <ul class="ulB">
              <li v-for="item in loginDateList">
                {{item}}
              </li>
          </ul>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="logDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import { getPagePlan } from "@/http/modules/examSet/examBatch";
import { getSessionListApi } from "@/http/modules/examSet/examActivity";
import { getExamLoginAbnormalFn,getExamLoginAbnormalInfoFn, } from "@/http/modules/examSet/examLogin";

export default {
  name: "examLoginAbnormal",
  data () {
    return {
      logData:{
        realName: "",
        entranceCode: "",
        cardNo: "",
      },
      logDialog: false,
      getLoading: false,
      loginDateList: [],
      planList: [],
      sessionList: [],
      selectForm: {
        planId: "",
        sessionId: "",
        queryDate: "",
        queryTimeL: "",
        queryTimeR: "",
        page: 1,
        size: 10
      },
      tableHeader: [
        {
          title: "学生姓名",
          prop: "realName",
        },
        {
          title: "准考证号",
          prop: "entranceCode",
        },
        {
          title: "证件号码",
          prop: "cardNo",
        },
        {
          title: "课程名称",
          prop: "courseName"
        },
        {
          title: "场次",
          prop: "sessionName"
        },
        {
          title: "考点",
          prop: "placeName"
        },
        {
          title: "教室",
          prop: "className"
        },
        {
          title: "座位号",
          prop: "seatNo"
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "查看",
              click: this.lookLog,
            },
          ],
        }
      ],
      tableData: [],
      pagination: {
        total: 0
      },
    }
  },
  mounted () {
    this.initData();
  },

  methods: {
    async initData() {
      const { data: planList } = await getPagePlan({ publish: 1})
      this.planList = planList
      this.selectForm.planId = planList[0].id
      this.getSessionList()
    },
    async getSessionList() {
      const { data: secionList } =  await getSessionListApi({planId: this.selectForm.planId})
      // this.sessionList = [{name:"全部", id: ""}, ...secionList]
      this.sessionList = secionList
      this.selectForm.sessionId = ""
    },
    /**********************************
     * @getResult 获取表格数据
     **********************************/
    async getResult () {
      if(!this.selectForm.sessionId){
        this.$message.warning("请选择场次");
        return
      }
      if(!this.selectForm.queryDate){
        this.$message.warning("请选择登录日期");
        return
      }
      if(this.selectForm.queryTimeL === ''){
        this.$message.warning("请选择登录日期的开始小时");
        return
      }
      if(this.selectForm.queryTimeR === ''){
        this.$message.warning("请选择登录日期的结束小时");
        return
      }
      if(this.selectForm.queryTimeR - this.selectForm.queryTimeL > 6){
        this.$message.warning("查询时间只能在6个小时以内");
        return
      }
      const {code,data} = await getExamLoginAbnormalFn(this.selectForm);
      if(code === 1) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }else{
        this.tableData = [];
        this.pagination.total = 0;
      }
    },
    /* *** 分页相关 *** */
    changeSize(num) {
        this.selectForm.size=num
        this.getResult()
    },

    /* *** 分页相关 *** */
    changePage(p) {
        this.selectForm.page=p
        this.getResult()
    },
    async lookLog(row){
      this.logData.realName = row.realName;
      this.logData.entranceCode = row.entranceCode;
      this.logData.cardNo = row.cardNo;
      this.logDialog = true;

      let params = {
        queryDate: this.selectForm.queryDate,
        queryTimeL: this.selectForm.queryTimeL,
        queryTimeR: this.selectForm.queryTimeR,
        userId: row.userId
      }
      this.getLoading = true;
      const {code,data} = await getExamLoginAbnormalInfoFn(params)
      if(code === 1) {
        this.loginDateList = data;
        this.getLoading = false;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.examLoginAbnormal /deep/ .el-form-item__content {
  display: flex;
}
.ulA{
  list-style: none;
  li{
    padding: 5px 0;
  }
  span{
    color: #409EFF;
  }
}
.ulB{
  margin-left: 70px;
  list-style: none;
  li{
    padding: 5px 0;
  }
}
.ShortSelect {
  /deep/ .el-select {
    width: 120px;
    .el-input {
      width: 120px;
      .el-input__inner {
        width: 120px;
      }
    }
  }
}
</style>